// components/WatchPurchaseGrid.js
import React from 'react';
import styles from './WatchPurchaseGrid.module.scss';
import {useNavigate} from "react-router-dom";

const WatchPurchaseGrid = () => {
  const watchBrands = [
    {
      name: "Ručne satove poznatih brendova",
      image: "assets/images/Rolex.jpg",
      models: ["Rolex, Omega, Cartier, TAG Heuer, Longines, Patek Philippe, Breitling, Zenith, Tissot i dr."]
    },
    {
      name: "Zlatne i srebrne satove",
      image: "assets/images/RolexZlatni.jpg",
      models: ["Stari i novi modeli"]
    },
    {
      name: "Kolekcionarske i limitirane serije satova",
      image: "assets/images/OmegaLimitiranaSerija.jpg",
      models: [""]
    },
    {
      name: "Mehaničke i automatske satove",
      image: "assets/images/audemars.webp",
      models: ["Kao i retke kvarcne modele"]
    },
    {
      name: "Antikvitetne džepne satove svih proizvođača",
      image: "assets/images/dzepni.jpg",
      models: [""]
    },
  ];

  const navigate = useNavigate();

  const handleClick = (brandName) => {
    const urlName = brandName.toLowerCase().replace(/\s+/g, "-"); // "Audemars Piguet" -> "audemars-piguet"
    window.location.href = `/brands/${urlName}`;
  };

  return (
    <section className={styles.watchPurchaseGrid}>
      <div className={styles.container}>
        <h1 className={styles.sectionTitle}>Otkupljujemo:</h1>
        <h2 className={styles.sectionTitle}>⌚ Ručne i džepne satove</h2>

        <div className={styles.grid}>
          {watchBrands.map((brand, index) => (
            <div key={index} className={styles.brandCard}>
              <div className={styles.brandHeader}>
                <h3>OTKUPLJUJEMO</h3>
                <h4>{brand.name}</h4>
                {/*<p>satova</p>*/}
              </div>

              <div className={styles.brandImage}>
                <img src={brand.image} alt={brand.name} />
              </div>

              <div className={styles.models}>
                {brand.models.map((model, idx) => (
                  (
                    idx === brand.models.length - 1 ?
                      <p>{model}</p>
                      :
                      <span>{model}, </span>
                  )
                ))}
              </div>

              <button className={styles.inquiryBtn} onClick={() => handleClick(brand.name)}>Saznaj više</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WatchPurchaseGrid;